import styled, { css } from 'styled-components'
import { Top, BackButton } from '../../../components/BackButton/styles'

export const Container = styled.div`
  display: flex;
`
export const MainContainer = styled.div`
  flex: 0 auto;
  margin: 0 auto;

  ${Top} {
    width: 100%;
  }

  ${BackButton} {
    margin: 0;
    color: #028BB7;
    height: 48px;
    border-color: #028BB7;
    font-weight: 600;

    svg {
      width: 24px;
      height: 24px;
      path {
        fill: #028BB7;
      }
    }
  }
`
